// Import fonctions JS
import "./js/index";
import "./js/function-eveno.js";

// Import style parent + nouveaux styles
import "./templates/style.css";
import "./styles/index.scss";



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0